import useUser from "../../../../core/hooks/use-user";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import useModal from "../../../../core/hooks/use-modal";
import FormHorasExtras from "../components/form-horas-extras";
import { useState } from "react";
import {
    eliminarHorasExtras,
    obtenerHoraExtra,
} from "../../services/horas-extras-service";
import BotonEnviarHorasExtras from "../components/boton-enviar-horas-extras";
import BtnEnviarHorasExtrasContext, {
    BotonEnviarHorasExtrasProvider,
} from "../../../NominaCuadrosTurnos/store/boton-enviar-horas-extras-context";
import { useContext } from "react";
import swal from "sweetalert";

const HorasExtrasView = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});
    const { actualizarBotonHorasExtras } = useContext(
        BtnEnviarHorasExtrasContext
    );

    const modalHorasExtras = useModal({
        title: "Crear horas extras",
        data: { horasExtras: {} },
    });

    const onSaved = (mensaje) => {
        modalHorasExtras.set({ show: false });
        sweetAl.warning(mensaje);
        dtInstance.ajax.reload();
        actualizarBotonHorasExtras();
    };

    const onHorasExtras = () => {
        dtInstance.ajax.reload();
    };

    const getDtInstance = (dt) => onDtInstance(dt);
    let tableButtons = [];

    if (userCan("crearHorasExtras")) {
        tableButtons.push({
            titleAttr: "Crear horas extras",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalHorasExtras.set({
                    show: true,
                    title: "Crear horas extras",
                    data: { horasExtras: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("nominaEditarHoraExtra")) {
        tableButtons.push({
            titleAttr: "Editar horas extras",
            text: '<i class="fas fa-pen"></i>',
            action: async function (e, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await obtenerHoraExtra(
                    data.fecha,
                    data.persona_id
                );
                const horasExtras = {
                    ...resp.data,
                    empleados: resp.data.info_persona.map((persona) => {
                        return {
                            label: persona.nombre.replace(/[^a-zA-Z ]/g, ""),
                            value: persona.id_persona,
                        };
                    }),
                    sede_area_lider: resp.data.info_sede_area.map(
                        (sedeArea) => {
                            return {
                                label: sedeArea.nombre_area.replace(
                                    /[^a-zA-Z ]/g,
                                    ""
                                ),
                                value: sedeArea.sede_has_area_id,
                            };
                        }
                    ),
                };

                modalHorasExtras.set({
                    show: true,
                    title: "Editar Hora Extra",
                    data: { horasExtras },
                });
            },
            className: "btn btn-sm btn-primary",
        });
    }

    if (userCan("nominaEliminarHorasExtras")) {
        tableButtons.push({
            titleAttr: "Inactivar hora extra",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea eliminar estas horas extras?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se han eliminado las horas extras");
                        break;
                    case "eliminar": {
                        const resp = await eliminarHorasExtras(
                            data.id_horas_extras
                        );
                        if (!resp.status) {
                            return sweetAl.error(
                                resp.message
                            );
                        }

                        sweetAl.success(resp.message);
                        actualizarBotonHorasExtras();
                        toast.success(resp.message);
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "horas-extras-creadas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaHorasExtras",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/turnos/horasExtras/creadas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de horas extras"
                );
            },
        },
        columns: [
            { data: "id_horas_extras" },
            { data: "nombres_persona" },
            { data: "nombre_area" },
            { data: "fecha" },
            { data: "observacion" },
            { data: "diurna" },
            { data: "nocturna" },
            { data: "diurna_festiva" },
            { data: "nocturna_festiva" },
            { data: "total_horas" },
            { data: "nombre_estado" },
        ],
        columnDefs: [
            {
                targets: [10],
                createdCell: function (td, cellData) {
                    td.classList.add(
                        cellData == "GUARDADO"
                            ? "text-primary"
                            : cellData == "EN ESPERA GERENCIA"
                            ? "text-secondary"
                            : cellData == "ACEPTADO POR GERENCIA"
                            ? "text-warning"
                            : cellData == "RECHAZADO POR GERENCIA"
                            ? "text-danger"
                            : "text-success"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>NÓMINA / Horas extras</div>
            </div>
            <div style={{ float: "right", padding: "5px" }}>
                <BotonEnviarHorasExtras onHorasExtras={onHorasExtras} />
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaHorasExtras"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">
                                Colaborador
                            </th>
                            <th className="text-center text-white">Area</th>
                            <th className="text-center text-white">
                                Fecha Hora Extra
                            </th>
                            <th className="text-center text-white">
                                Observación
                            </th>
                            <th className="text-center text-white">Diurnas</th>
                            <th className="text-center text-white">
                                Nocturnas
                            </th>
                            <th className="text-center text-white">
                                Diurnas festiva
                            </th>
                            <th className="text-center text-white">
                                Nocturnas festiva
                            </th>
                            <th className="text-center text-white">
                                Total Horas
                            </th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormHorasExtras modalState={modalHorasExtras} onSaved={onSaved} />
        </ContentWrapper>
    );
};

const HorasExtras = () => {
    return (
        <BotonEnviarHorasExtrasProvider>
            <HorasExtrasView></HorasExtrasView>
        </BotonEnviarHorasExtrasProvider>
    );
};

export default HorasExtras;
